import { RootState } from "@/app/stores"
import { searchFlights, ISearchFlightsResponse, IPassenger, TClassOfService } from "@/shared/api/aviabooking"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

export interface FetchFlightsPayload {
    from: string
    dest: string
    date: Date
    backDate: Date | null
    passengers: IPassenger[]
    classOfService: TClassOfService
}

export const fetchFlights = createAsyncThunk<
    ISearchFlightsResponse,
    FetchFlightsPayload,
    { state: RootState }
>('aviabooking/fetchFlights', async(payload, thunkAPI) => {
    try {
        const response = await searchFlights({
            date: payload.date.toISOString(),
            backDate: payload.backDate ? payload.backDate.toISOString(): undefined,
            departure: payload.from,
            arrival: payload.dest,
            depIsCity: false,
            arrIsCity: false,
            passengers: payload.passengers.filter(passenger => passenger.count > 0),
            classOfService: payload.classOfService,
            directOnly: false
        })
        return response.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})
